module.exports = __webpack_public_path__ + "img/one.1d50422e.jpg";